"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_START = exports.VIDEO_RESUME = exports.VIDEO_PROGRESS_95 = exports.VIDEO_PROGRESS_75 = exports.VIDEO_PROGRESS_50 = exports.VIDEO_PROGRESS_25 = exports.VIDEO_PAUSE = exports.VIDEO_COMPLETE = exports.VIDEO_BUFFER = exports.USER_FORGOT_USERNAME = exports.USER_FORGOT_PASSWORD = exports.TOOL_SUBMIT = exports.TOOL_STEP = exports.TOOL_START = exports.TOOL_ERROR = exports.TOOL_COMPLETE = exports.TOOL_CANCEL = exports.TOGGLE_CLICKS = exports.SURVEY_SUBMIT = exports.STORE_CLICKS = exports.SSA_START = exports.SSA_COMPLETE = exports.SHARE_CLICKS = exports.SEARCH_REFINEMENT = exports.SEARCH = exports.REMOVE_FROM_CART = exports.REGISTRATION_START = exports.REGISTRATION_COMPLETE = exports.PURCHASE = exports.PROD_VIEW = exports.PRODUCT_IMPRESSIONS = exports.PRODUCT_CART_VIEWS = exports.PRINT_CLICKS = exports.PAGE_LOADED = exports.OFFER_INTERACTIONS = exports.OFFER_IMPRESSIONS = exports.NOTIFICATION_IMPRESSIONS = exports.NOTIFICATION_DISMISSALS = exports.LOGOUT = exports.LOGIN_START = exports.LOGIN_COMPLETE = exports.LINK_CLICKS = exports.FORM_STEP = exports.FORM_START = exports.FORM_COMPLETE = exports.EXPERIENCE = exports.EXIT_CLICKS = exports.ERROR_EVENT = exports.EMAIL_CLICKS = exports.DOWNLOAD_CLICKS = exports.CHECKOUT_VIEWS = exports.CHAT_RETURN = exports.CHAT_RESPONSE = exports.CHAT_REQUEST = exports.CHAT_OFFERED = exports.CHAT_MINIMIZED = exports.CHAT_INITIATED = exports.CHAT_FAILURE = exports.CHAT_END = exports.CHAT_DECLINED = exports.CHAT_COMPLETED = exports.CHAT_CLOSE = exports.CHAT_CLICKED = exports.CHAT_CANCELLED = exports.CALL_CLICKS = exports.ADD_TO_CART = void 0;
var ADD_TO_CART = exports.ADD_TO_CART = 'addToCart';
var CALL_CLICKS = exports.CALL_CLICKS = 'callClicks';
var CHAT_CANCELLED = exports.CHAT_CANCELLED = 'chatCancelled';
var CHAT_CLICKED = exports.CHAT_CLICKED = 'chatClicked';
var CHAT_CLOSE = exports.CHAT_CLOSE = 'chatClose';
var CHAT_COMPLETED = exports.CHAT_COMPLETED = 'chatCompleted';
var CHAT_DECLINED = exports.CHAT_DECLINED = 'chatDeclined';
var CHAT_END = exports.CHAT_END = 'chatEnd';
var CHAT_FAILURE = exports.CHAT_FAILURE = 'chatFailure';
var CHAT_INITIATED = exports.CHAT_INITIATED = 'chatInitiated';
var CHAT_MINIMIZED = exports.CHAT_MINIMIZED = 'chatMinimized';
var CHAT_OFFERED = exports.CHAT_OFFERED = 'chatOffered';
var CHAT_REQUEST = exports.CHAT_REQUEST = 'chatRequest';
var CHAT_RESPONSE = exports.CHAT_RESPONSE = 'chatResponse';
var CHAT_RETURN = exports.CHAT_RETURN = 'chatReturn';
var CHECKOUT_VIEWS = exports.CHECKOUT_VIEWS = 'checkoutViews';
var DOWNLOAD_CLICKS = exports.DOWNLOAD_CLICKS = 'downloadClicks';
var EMAIL_CLICKS = exports.EMAIL_CLICKS = 'emailClicks';
var ERROR_EVENT = exports.ERROR_EVENT = 'errorEvent';
var EXIT_CLICKS = exports.EXIT_CLICKS = 'exitClicks';
var EXPERIENCE = exports.EXPERIENCE = 'experience';
var FORM_COMPLETE = exports.FORM_COMPLETE = 'formComplete';
var FORM_START = exports.FORM_START = 'formStart';
var FORM_STEP = exports.FORM_STEP = 'formStep';
var LINK_CLICKS = exports.LINK_CLICKS = 'linkClicks';
var LOGIN_COMPLETE = exports.LOGIN_COMPLETE = 'loginComplete';
var LOGIN_START = exports.LOGIN_START = 'loginStart';
var LOGOUT = exports.LOGOUT = 'logout';
var NOTIFICATION_DISMISSALS = exports.NOTIFICATION_DISMISSALS = 'notificationDismissals';
var NOTIFICATION_IMPRESSIONS = exports.NOTIFICATION_IMPRESSIONS = 'notificationImpressions';
var OFFER_IMPRESSIONS = exports.OFFER_IMPRESSIONS = 'offerImpressions';
var OFFER_INTERACTIONS = exports.OFFER_INTERACTIONS = 'offerInteractions';
var PAGE_LOADED = exports.PAGE_LOADED = 'pageLoaded';
var PRINT_CLICKS = exports.PRINT_CLICKS = 'printClicks';
var PROD_VIEW = exports.PROD_VIEW = 'prodView';
var PRODUCT_CART_VIEWS = exports.PRODUCT_CART_VIEWS = 'productCartViews';
var PRODUCT_IMPRESSIONS = exports.PRODUCT_IMPRESSIONS = 'productImpressions';
var PURCHASE = exports.PURCHASE = 'purchase';
var REGISTRATION_COMPLETE = exports.REGISTRATION_COMPLETE = 'registrationComplete';
var REGISTRATION_START = exports.REGISTRATION_START = 'registrationStart';
var REMOVE_FROM_CART = exports.REMOVE_FROM_CART = 'removeFromCart';
var SEARCH = exports.SEARCH = 'search';
var SEARCH_REFINEMENT = exports.SEARCH_REFINEMENT = 'searchRefinement';
var SHARE_CLICKS = exports.SHARE_CLICKS = 'shareClicks';
var SSA_COMPLETE = exports.SSA_COMPLETE = 'ssaComplete';
var SSA_START = exports.SSA_START = 'ssaStart';
var STORE_CLICKS = exports.STORE_CLICKS = 'storeClicks';
var SURVEY_SUBMIT = exports.SURVEY_SUBMIT = 'surveySubmit';
var TOGGLE_CLICKS = exports.TOGGLE_CLICKS = 'toggleClicks';
var TOOL_CANCEL = exports.TOOL_CANCEL = 'toolCancel';
var TOOL_COMPLETE = exports.TOOL_COMPLETE = 'toolComplete';
var TOOL_ERROR = exports.TOOL_ERROR = 'toolError';
var TOOL_START = exports.TOOL_START = 'toolStart';
var TOOL_STEP = exports.TOOL_STEP = 'toolStep';
var TOOL_SUBMIT = exports.TOOL_SUBMIT = 'toolSubmit';
var USER_FORGOT_PASSWORD = exports.USER_FORGOT_PASSWORD = 'userForgotPassword';
var USER_FORGOT_USERNAME = exports.USER_FORGOT_USERNAME = 'userForgotUsername';
var VIDEO_BUFFER = exports.VIDEO_BUFFER = 'videoBuffer';
var VIDEO_COMPLETE = exports.VIDEO_COMPLETE = 'videoComplete';
var VIDEO_PAUSE = exports.VIDEO_PAUSE = 'videoPause';
var VIDEO_PROGRESS_25 = exports.VIDEO_PROGRESS_25 = 'videoProgress25';
var VIDEO_PROGRESS_50 = exports.VIDEO_PROGRESS_50 = 'videoProgress50';
var VIDEO_PROGRESS_75 = exports.VIDEO_PROGRESS_75 = 'videoProgress75';
var VIDEO_PROGRESS_95 = exports.VIDEO_PROGRESS_95 = 'videoProgress95';
var VIDEO_RESUME = exports.VIDEO_RESUME = 'videoResume';
var VIDEO_START = exports.VIDEO_START = 'videoStart';